import { productListButtonsStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaProductListButtons";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

productListButtonsStyles.gridContainer = {
    ...productListButtonsStyles.gridContainer,

    css: css`
        margin-top: 30px;
    `,
};

productListButtonsStyles.buttonsGridItem = {
    ...productListButtonsStyles.buttonsGridItem,

    width: [12, 12, 12, 0, 0],

    css: css`
        ${productListButtonsStyles.buttonsGridItem?.css}

        align-items: center;
        justify-content: center;

        & > [class*="HiddenStyle"] {
            &:first-child {
                display: none;
            }

            &:last-child {
                display: block;

                ${mediaQueriesBP.minMD} {
                    display: none;
                }
            }
        }
    `,
};
